import { BankTransaction } from "../../../../../../../../../../../services";
import ArchiveOrderFiltersModal from "..";

const applyFilters = (
	models: BankTransaction.Model[],
	valueModal: ArchiveOrderFiltersModal.Value,
): BankTransaction.Model[] => {
	let retval = models;

	// filter remountTransactionType
	if (valueModal.checkRemountTransactionType) {
		if (valueModal.remountTransactionType?.length) {
			retval = retval.filter((order) => {
				const value = order.remountTransactionType;
				if (!value) return false;

				return valueModal.remountTransactionType.includes(value);
			});
		} else {
			retval = [];
		}
	}

	// filter status
	if (valueModal.checkStatus) {
		if (valueModal.status?.length) {
			retval = retval.filter((order) => {
				const value = order.status;
				if (!value) return false;

				return valueModal.status.includes(value);
			});
		} else {
			retval = [];
		}
	}

	// filter transactionType
	if (valueModal.checkTransactionType) {
		if (valueModal.transactionType?.length) {
			retval = retval.filter((order) => {
				const value = order.type;
				if (!value) return false;

				return valueModal.transactionType.includes(value);
			});
		} else {
			retval = [];
		}
	}

	return retval;
};

export default applyFilters;
